import { render } from "./filters.vue?vue&type=template&id=0967d915&scoped=true"
import script from "./filters.vue?vue&type=script&lang=ts"
export * from "./filters.vue?vue&type=script&lang=ts"

import "./filters.vue?vue&type=style&index=0&id=0967d915&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0967d915"

export default script